<template>
  <div class="website">
    <div class="banner">
      <div class="logo">
        <img :src="logo"/>
      </div>
      <div class="log_in">
        <p  @click="toRegister">注册</p>
        <p  @click="toLoginPage">登录</p>
      </div>
      <div class="nav">
        <div class="navdh">
          <div id="myDiv" class="words" v-for="(item, index) in navwords" :key="index" :class="{ active: activeIndex === index }" @click="setActive(index)">
            {{ item.text }}
          </div>
        </div>
      </div>
    </div>
    <!-- 首页 -->
      <div class="new" v-show="hasActiveClass">

        <!-- <div class="person">
          <p>科技查新</p>
          <div class="scroll-container">
            <a v-for="(image, index) in images" :key="index" :href="image.link" target="_blank" class="scroll-item">
              <img :src="image.src" :alt="image.alt">
            </a>
          </div>
        </div> -->

        <div class="news_top">
          <div class="newsone">
            <p>行业动态</p>
            <div class="list" v-for="(item,index) in contextItems1"  :key="item.id">
              <span @click="handleClick(item.id)" class="clickable-link">{{item.contentTitle}}</span>            
            </div>
          </div>
          <div class="newsone">
            <p>转化公示</p>
            <div class="list" v-for="(item,index) in contextItems2"  :key="item.id">
              <span @click="handleClick(item.id)" class="clickable-link">{{item.contentTitle}}</span>            
            </div>
          </div>
        </div>
        <div class="news_middle">
          <div class="newsone">
            <p>服务流程</p>
            <div class="list" v-for="(item,index) in contextItems3"  :key="item.id">
              <span @click="handleClick(item.id)" class="clickable-link">{{item.contentTitle}}</span>            
            </div>
          </div>
          <div class="newsone">
            <p>服务内容</p>
            <div class="list" v-for="(item,index) in contextItems4"  :key="item.id">
              <span @click="handleClick(item.id)" class="clickable-link">{{item.contentTitle}}</span>            
            </div>
          </div>
        </div>


        <!-- <div class="person">
          <p>知名专家</p>
          <div class="list">
            <div v-for="(item,index) in exportItems5"  :key="item.id">
              <img :src= "getImgView(item.expertImage)" @click="clickExport(item.id)" class="clickable-link"/> 
            </div>
          </div> -->
          <!-- <div class="list">   
            <img :src="export1"/>
            <img :src="export2"/>
            <img :src="export3"/>
            <img :src="export4"/>
            <img :src="export5"/>
            <img :src="export6"/>
          </div> -->
          <!-- <div class="list" v-for="(item,index) in exportItems5"  :key="item.id">   
            <img :src= "getImgView(item.expertImage)"/>                    
          </div> -->
        <!-- </div> -->
        <div class="news_bottom">
          <div class="newsone">
            <p>国家政策</p>
            <div class="list" v-for="(item,index) in policyItems"  :key="item.id"> 
              <span @click="clickPolicy(item.standardsUrl)" class="clickable-link">{{item.standardsTitle}}</span> 
              <!-- <span>关于举办初级技术经纪人暨关于举办初级技术经纪人暨“标准助推科技成果转化”培训班的通知</span>
              <span>关于举办初级技术经纪人暨关于举办初级技术经纪人暨“标准助推科技成果转化”培训班的通知</span>
              <span>关于举办初级技术经纪人暨关于举办初级技术经纪人暨“标准助推科技成果转化”培训班的通知</span>
              <span>关于举办初级技术经纪人暨关于举办初级技术经纪人暨“标准助推科技成果转化”培训班的通知</span>
              <span>关于举办初级技术经纪人暨关于举办初级技术经纪人暨“标准助推科技成果转化”培训班的通知</span> -->
            </div>
          </div>
          <div class="newsone">
            <p>评价标准</p>
            <div class="list" v-for="(item,index) in standardItems"  :key="item.id">
              <span @click="clickPolicy(item.standardsUrl)" class="clickable-link">{{item.standardsTitle}}</span> 
              <!-- <span>关于举办初级技术经纪人暨关于举办初级技术经纪人暨“标准助推科技成果转化”培训班的通知</span>
              <span>关于举办初级技术经纪人暨关于举办初级技术经纪人暨“标准助推科技成果转化”培训班的通知</span>
              <span>关于举办初级技术经纪人暨关于举办初级技术经纪人暨“标准助推科技成果转化”培训班的通知</span>
              <span>关于举办初级技术经纪人暨关于举办初级技术经纪人暨“标准助推科技成果转化”培训班的通知</span>
              <span>关于举办初级技术经纪人暨关于举办初级技术经纪人暨“标准助推科技成果转化”培训班的通知</span> -->
            </div>
          </div>
        </div>
      </div>


      <!-- 网站底部操作栏 -->
      <div class="bottom">
           <a href="https://beian.miit.gov.cn/" target="_blank">
         冀ICP备2025101159号
        </a>
        <!-- <div class="b_top">
          <div>法律声明</div>
          <div>服务指南</div>
          <div>使用帮助</div>
          <div>问卷调查</div>
        </div> -->
        <!-- <div class="b_footer">
          
        </div> -->
        <!-- <div class="b_footer1">
          地址:XXXXXXXXXXX 邮编:XXXXXX 业务咨询电话:XXXXXXXXXXX 技术支持电话:联系人1:XXXXXXXXXXX、联系人2:XXXXXXXXXXX 各市地登记
        </div> -->
        <!-- <img :src="blue"/> -->
      </div>
  </div>
  <div class="fab-container">
    <el-button @click="handleChat()" class="fab-button" ><el-icon><ChatDotRound /></el-icon>添加微信</el-button>
    <button @click="handleTel()" class="fab-button" style="margin-top: 3px;margin-bottom: 3px;"><el-icon><Phone /></el-icon>联系我们</button>
    <button @click="handleContact()" class="fab-button" style="margin-top: 3px;margin-bottom: 3px;"><el-icon><Phone /></el-icon>留言</button>
  </div>
  <!-- 添加微信 -->
  <div v-show="isVisibleChat" class="dialog-overlay">
    <div class="dialog-content" @click.stop>
      <p>扫描添加</p>
      <div>
        <img alt="扫码添加" style="width: 200px; height: 200px" :src="singqr" >
      </div>     
      <el-button type="primary" @click="handleChat">关闭</el-button>
    </div>
  </div>

  <!-- 联系我们 -->
  <div v-show="isVisibleTel" class="dialog-overlay">
    <div class="dialog-content" @click.stop>
      <div style="text-align: left;margin: 30px;">
        <i class="el-icon-edit"></i>
        <h3>联系我们：</h3>
        <el-divider></el-divider>
        <p>联系人：马老师</p>
        <p>联系电话：18600868978</p>
        <el-divider></el-divider>
        <!-- <span>青春是一个短暂的美梦, 当你醒来时, 它早已消失无踪</span>       
        <span>少量的邪恶足以抵消全部高贵的品质, 害得人声名狼藉</span> -->
      </div>     
      <el-button type="primary" style="text-align: right;"  @click="handleTel">关闭</el-button>
    </div>
  </div>
  <!-- 咨询留言 -->
  <div v-show="isVisibleContact" class="dialog-overlay">
    <div class="dialog-content" @click.stop>
      <h3 style="text-align: left;">留言：</h3>
      <form @submit.prevent="handleSubmit">        
        <div class="form-group">
          <label for="entrustingUnit">单位（人）信息:</label>
          <input type="text" v-model="indexSearchNew.entrustingUnit" class="formFont">
        </div>
        <div class="form-group">
          <label for="contacts">联系人:</label>
          <input type="text" v-model="indexSearchNew.contacts" class="formFont">
        </div>
        <div class="form-group">
          <label for="tel">联系电话:</label>
          <input type="tel" v-model="indexSearchNew.contactsPhone" class="formFont" @change="checkTel">
        </div>
        <div class="form-group">
          <label for="projectName">留言:</label>
          <input type="text" v-model="indexSearchNew.projectName" class="formFont">
        </div>
        <!-- 可以添加更多的表单组 -->
        <div class="form-group">
          <el-button type="primary" style="text-align: center;"  @click="handleContact">关闭</el-button>
          <el-button type="primary" style="text-align: center;"  @click="submitData">提交留言</el-button>
        </div>
      </form>
    </div>
    
  </div>
</template>

<script>
    import {getContextList,getExportList,getFileAccessHttpUrl,getPolicyList,getPdfAction,submitDataIndexSearchNew } from "@/api/api"
    import { ElMessage } from "element-plus";
    import logo from '@/assets/logo/indexLogo.png'
    import person from '@/assets/logo/person.jpg'  
    import blue from '@/assets/logo/blue.png'
    import { ref, reactive,onMounted, watch } from "vue";
    import export1 from '@/assets/logo/export1.png'
    import export2 from '@/assets/logo/export2.jpg'
    import export3 from '@/assets/logo/export3.jpg'
    import export4 from '@/assets/logo/export4.jpg'
    import export5 from '@/assets/logo/export5.jpg'
    import export6 from '@/assets/logo/export6.jpg'
    import company from '@/assets/logo/company1.jpg'
    import company2 from '@/assets/logo/company2.jpg'
    
    import img1 from '@/assets/logo/img1.jpg'
    import img2 from '@/assets/logo/img2.png'
    import img3 from '@/assets/logo/img3.png'
    import singqr from '@/assets/logo/singqr.png'
    //  import pdf from '@/assets/11.pdf'
    export default {
      name: 'websiteIndexPage',
        components: {
          // PaginationTest
        },
        mounted(){
      },
      created() {
        // 从其他页面跳转过来接受参数
        if(this.$route.query.param!=undefined&&this.$route.query.param!=''){
          this.activeIndex = parseInt(this.$route.query.param);
          this.setActive(this.activeIndex);         
        }
        // 加载首页的内容数据
        // this.fetchData(); 
      },
      computed: {
        
    },
    data () {
      return {
        singqr,
        isVisibleChat:false,  
        isVisibleTel:false,
        isVisibleContact:false,
        indexContext1:{},//首页加载数据---行业动态
        indexContext2:{},//首页加载数据---转化公式
        indexContext3:{},//首页加载数据---服务流程
        indexContext4:{},//首页加载数据---服务内容
        flag:false,
        indexSearchNew:{},//查新申请
        pdfUrl:'',
        // pdfUrl: '/11.pdf', // 假设PDF文件放在src/assets目录下 
        activeName: 'first',
        form:{},
        fruits:[
          '苹果',
          '梨'
        ],
        model:{
          name:'',
          person:'',
          contact:'',  
          tel:''
        },
        navwords:[
          {text: '首页' },
          {text: '项目评价' },
          {text: '政策标准' },
          {text: '成果检索' },
          {text: '科技查新' },
          // {text: '知名专家' }
          ],
        selectedOption:'',
        activeIndex:0,
        hasActiveClass:true,
        newscontent:false,
        newsTechnology:false,
        newsExport:false,
        newsSearch:false,//成果检索
        newsPolicy:false,//政策标准
        openPolicyDetail:false,//政策标准详细信息
        newsExportDetail :false,
        searchProjectDetail :false,//查询科技成果信息
        searchProjectList:false,//查询科技成果列表
        logo, 
        person,  
        blue,  
        flag:false,
        export1,
        export2,
        export3,
        export4,
        export5,
        export6,

        images: [
        // { src: export1, alt: 'Image 1', link: 'http://121.37.110.170:9000/' },
        // { src: export2, alt: 'Image 2', link: 'http://121.37.110.170:9000/' },
        // { src: export3, alt: 'Image 3', link: 'http://121.37.110.170:9000/' },
        // { src: export4, alt: 'Image 3', link: 'http://121.37.110.170:9000/' },
        // { src: export5, alt: 'Image 3', link: 'http://121.37.110.170:9000/' },
        // { src: export6, alt: 'Image 3', link: 'http://121.37.110.170:9000/' },
        { src: img1, alt: 'Image 3', link: 'http://121.37.110.170:9000/' },
        { src: company, alt: 'Image 3', link: 'http://121.37.110.170:9000/' },
        { src: company2, alt: 'Image 3', link: 'http://121.37.110.170:9000/' },       
        { src: img3, alt: 'Image 3', link: 'http://121.37.110.170:9000/' },
        { src: img1, alt: 'Image 3', link: 'http://121.37.110.170:9000/' },
        { src: company, alt: 'Image 3', link: 'http://121.37.110.170:9000/' },
        { src: company2, alt: 'Image 3', link: 'http://121.37.110.170:9000/' }
        // 添加更多图片数据
      ],
      }
    },
   

    setup() {
        const contextItems1 = ref([]);//行业动态
        const contextItems2 = ref([]);//转化公式
        const contextItems3 = ref([]);//服务流程
        const contextItems4 = ref([]);//服务内容
        const exportItems5 = ref([]);//知名专家
        const policyItems = ref([]);//国家政策
        const standardItems = ref([]);//评价标准
        const additionalData1 = reactive({
          contentType:'1'
        }); // 使用 reactive 来定义一个响应式对象
        const additionalData2 = reactive({
          contentType:'2'
        });
        const additionalData3 = reactive({
          contentType:'3'
        });
        const additionalData4 = reactive({
          contentType:'4'
        });

        const additionalData5 = reactive({
          standardsType:'国家政策'
        });
        const additionalData6 = reactive({
          standardsType:'评价标准'
        });
        // 在组件挂载后发送请求到后端
        onMounted(async () => {
          try {
            // 获取行业动态
            const responseData1 = await getContextList(additionalData1);
            contextItems1.value = responseData1.slice(0, 5);; // 将后端返回的数据赋值给 items 引用

            // 获取转化公式
            const responseData2 = await getContextList(additionalData2);
            contextItems2.value = responseData2.slice(0, 5);; // 将后端返回的数据赋值给 items 引用

             // 获取服务流程
             const responseData3 = await getContextList(additionalData3);
            contextItems3.value = responseData3.slice(0, 5);; // 将后端返回的数据赋值给 items 引用

             // 获取服务内容
             const responseData4 = await getContextList(additionalData4);
            contextItems4.value = responseData4.slice(0, 5);; // 将后端返回的数据赋值给 items 引用

            
             // 获取知名专家
            const responseData5 = await getExportList();
            exportItems5.value = responseData5.slice(0, 6); // 将后端返回的数据赋值给 items 引用

            // 获取国家政策
            const responseData6 = await getPolicyList(additionalData5);
            policyItems.value = responseData6.slice(0, 5); // 将后端返回的数据赋值给 items 引用

             // 获取知名专家
             const responseData7 = await getPolicyList(additionalData6);
             standardItems.value = responseData7.slice(0, 5); // 将后端返回的数据赋值给 items 引用

          } catch (error) {
            console.error('Error fetching data:', error);
          }
        });
    
        return {
          contextItems1 ,
          contextItems2 ,
          contextItems3 ,
          contextItems4 ,
          exportItems5,
          additionalData1,
          additionalData2,
          additionalData3,
          additionalData4,
          additionalData5,
          additionalData6,
          policyItems,
          standardItems
        };
    },
    methods:{
     //加载首页的数据 

    //  fetchData() {
    //   this.indexContext1.contentType = '行业动态'
    //   getContextList(this.indexContext1).then(responseData => {
    //       this.contextItems1 = responseData;
    //       console.log('this.contextItems1 ------------------', this.contextItems1);
    //   }).catch(error => {
    //     console.error('Error fetching data:', error);
    //     // 处理错误，例如更新组件状态或显示错误消息
    //   });
    // },


      // async fetchData(){
      //   // 行业动态
      //   this.indexContext1.contentType = '行业动态'
      //   const responseData = await getContextList(this.indexContext1);      
      //   this.contextItems1 =  responseData;
      //   console.log('this.contextItems1 ------------------',this.contextItems1);
      // },

      // 点击行业动态、转化公示、服务流程、服务内容当前页面跳转显示详细内容
      handleClick(id){
        console.log("this.contextDetail-----------------",id);
        let pathHerf = this.$router.resolve({
            path:'/contextDetail', 
            query:{
                  id: id,                  
                  }
          })
        window.open(pathHerf.href, '_self');       
        // window.open('/exportDetail', '_self');
      },


      // 点击专家图片
      clickExport(id){
        console.log("this.exportDetail-----------------",id);
        let pathHerf = this.$router.resolve({
            path:'/exportDetail', 
            query:{
                  id: id,                  
                  }
          })
        window.open(pathHerf.href, '_self');       
      },

      //点击国家政策\评价标准
      clickPolicy(standardsUrl){
        this.fetchPdf(standardsUrl);
      },  

      fetchPdf(filePathContext){
          var that = this;
          getPdfAction(filePathContext).then((res)=>{
            console.log('ok-------------------------',res);           
            const blob = new Blob([res], { type: 'application/pdf' });  
            // const blob = new Blob([bytes.buffer], { type: 'application/pdf' });  
            this.pdfUrl = URL.createObjectURL(blob);
            window.open(this.pdfUrl+'#toolbar=0', '_blank');
          });
      },

      //显示图片信息 
      getImgView(text){
        if(text && text.indexOf(",")>0){
        text = text.substring(0,text.indexOf(","))
        }
        return getFileAccessHttpUrl(text)
      },

     


      handleCurrentChange(page) {
        this.currentPage = page;
      },

      //导航点击
      setActive(index) {
        this.searchProjectList = false;
        this.searchProjectDetail = false;
        this.openPolicyDetail = false;
        this.newsExportDetail = false
        this.activeIndex = index;
        if(this.activeIndex == 0){
          this.hasActiveClass = true
          this.newscontent = false
          this.newsTechnology = false
          this.newsExport = false
          this.newsPolicy = false
          this.newsSearch = false
        }else if(this.activeIndex == 1){
          window.open('/projectEvaluation', '_self');
        }else if(this.activeIndex == 2){
          window.open('/policyList', '_self'); 
        }else if(this.activeIndex == 3){
          window.open('/projectSearch', '_self');                 
        }else if(this.activeIndex == 4){
          window.open('/projecteNewApply', '_self');
          // this.hasActiveClass = false
          // this.newscontent = false
          // this.newsTechnology = true
          // this.newsExport = false
          // this.newsPolicy = false
          // this.newsSearch = false
        }else if(this.activeIndex == 5){
          window.open('/exportList', '_self');
        }else{
          
        }
      },  
      toRegister(){
        window.open('https://kjpj.cnmspoep.com.cn/userregistermanage','_blank');
        // window.open('http://192.168.1.231:8580/userregistermanage','_blank');
      },
      toLoginPage(){
        window.open('https://kjpj.cnmspoep.com.cn/user/login','_blank');
        // window.open('http://192.168.1.231:8580/user/login','_blank');
      },
      handleChat(){       
        this.isVisibleChat = !this.isVisibleChat;          
      },      
      handleTel(){
        this.isVisibleTel= !this.isVisibleTel;
      },
      handleContact(){
        this.isVisibleContact= !this.isVisibleContact;
      },
      async submitData(){
        this.flag = false;
        //判空，所有值必须输入
        this.validateData(this.indexSearchNew);
        if(!this.flag){
          const responseData = await submitDataIndexSearchNew(this.indexSearchNew);   
          if (responseData.code === 200) {
            ElMessage.success("留言提交成功");
            this.isVisibleContact= !this.isVisibleContact;
          }   
        }
      },
      validateData(){
        if(this.indexSearchNew.projectName==null||this.indexSearchNew.projectName==''){
          this.flag = true;
          ElMessage.warning("请输入项目名称");
          return;
        }
        if(this.indexSearchNew.entrustingUnit==null||this.indexSearchNew.entrustingUnit==''){
          this.flag = true;
          ElMessage.warning("请输入委托单位（人）！");
          return;
        }
        if(this.indexSearchNew.contacts==null||this.indexSearchNew.contacts==''){
          this.flag = true;
          ElMessage.warning("请输入联系人！");
          return;
        }
        if(this.indexSearchNew.contactsPhone==null||this.indexSearchNew.contactsPhone==''){
          this.flag = true;
          ElMessage.warning("请输入联系电话！");
          return;
        }else{
          const regex = /^1[3-9]\d{9}$/;
          var checkFlag = regex.test(this.indexSearchNew.contactsPhone);
          if(!checkFlag){
            ElMessage.warning("请输入正确的手机号！");
            return;
          }
        }
      },
      checkTel(){
        console.log(this.indexSearchNew.contactsPhone);
        const regex = /^1[3-9]\d{9}$/;
        var checkFlag = regex.test(this.indexSearchNew.contactsPhone);
        if(!checkFlag){
          ElMessage.warning("请输入正确的手机号！");
        }
      }
    }

  }
</script>
<style lang="less" scoped>
  .user-layout-login {
    label {
      font-size: 14px;
    }
  .getCaptcha {
      display: block;
      width: 100%;
      height: 40px;
    }

  .forge-password {
      font-size: 14px;
    }

    button.login-button {
      padding: 0 15px;
      font-size: 16px;
      height: 40px;
      width: 100%;
    }

  .user-login-other {
      text-align: left;
      margin-top: 24px;
      line-height: 22px;

    .item-icon {
        font-size: 24px;
        color: rgba(0,0,0,.2);
        margin-left: 16px;
        vertical-align: middle;
        cursor: pointer;
        transition: color .3s;

      &:hover {
          color: #1890ff;
        }
      }

    .register {
        float: right;
      }
    }
  }
</style>
<style scoped>
  .valid-error .ant-select-selection__placeholder{
    color: #f5222d;
  }
  .website{
    width: 100% !important;
    height: 470px !important;
    position: absolute;
    top: 0;
    left:0;
  }
  .banner{
    width: 100%;
    height: 330px;
    position: absolute;
    top:0;
    background: url('@/assets/logo/banner1.jpg');
    background-size:100%  100%;
  }
  .logo img{
    width: 330px;
    height: 45px;
    display: block;
    float:left;
    margin-top: 30px;
    margin-left: 30px;
  }
  .nav{
    width: 100%;
    position: absolute;
    top: 270px;
    height: 62px;
    background-color: rgba(0,0,0,0.4);
  }
  .navdh{
    width: 1100px;
    margin: 0 auto;
    display:flex;
    justify-content: space-between; 
  }
  .words{
    width: 120px;
    text-align: center;
    cursor: pointer;
    color:#fff;
    font-size: 24px;
    line-height:62px;
  }
  .active{
    color: #fff;
    background-color: rgba(255,255,255,0.3);
  }
  .log_in{
    width: 220px;
    height: 40px;
    position: absolute;
    right: 40px;
    top: 20px;
  }
  .log_in p{
    width: 50px;
    height: 30px;
    line-height: 30px;
    background:url('@/assets/logo/gwicon2.png') no-repeat left center/30px 30px;
    color: #fff;
    border: none;
    margin: 6px 0;
    float: left;
    padding-left: 37px;
    font-size: 18px;
    border-right: 1px solid #fff;
    cursor: pointer;
  }
  .log_in p:last-child{
    background:url('@/assets/logo/gw_icon1.png') no-repeat left center/30px 30px;
    border-right: none;
    margin-left:10px
  }
  .new{
    width: 100%;
    min-height: 700px;
    background-color: #f5f5f5;
    margin-top: 330px;
    overflow-y: auto;
  }
  .news{
    width: 100%;
    min-height: 700px;
    background-color: #f5f5f5;
    margin-top: 330px;
    overflow-y: auto;
  }
  .content{
    background-color: #f5f5f5;
    width: 100%;
    margin-top: 330px;
  }
  .c_new{
    width: 92%;
    margin:0 auto;
    background-color: #fff;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    min-height: 400px;
    border-radius: 4px;
    border: 1px solid #EBEEF5;
    padding: 30px;
  }

  .c_new_2{
    width: 92%;
    margin:0 auto;
    background-color: #fff;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    min-height: 400px;
    border: 1px solid #EBEEF5;
    /* margin-bottom: 20px; */
  }
  .c_new_list{
    width: 92%;
    margin:0 auto;
    background-color: #fff;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    min-height: 400px;
    border-radius: 4px;
    border: 1px solid #EBEEF5;
    padding: 30px;
  }
  .c_new1{
	  min-height: 200px;
	  margin-top: 20px;
  }
  .c_new img{
    display: block;
    width: 590px;
    margin: 0 auto;
    margin-top: 30px;
  }
  .c_bottom{
    line-height: 28px;
    font-size: 16px;
  }
  .news_bottom{
    margin-bottom: 20px;
    width: 1400px;
    min-height: 200px;
    display:flex;
    justify-content: space-between;
    margin-left: auto;
    margin-right: auto;
    margin-top: 0;
    
  }
  /* ,.news_bottom */
  .news_top,.news_middle{
    width: 1400px;
    min-height: 200px;
    margin: auto;
    display:flex;
    justify-content: space-between; 
  }
  .newsone{
    width: 686px;
    height: 320px;
    color: #333;
    background-color: #fff;
    margin-top: 20px;
  }
  .newsone p{
    width: 93%;
    height: 46px;
    line-height: 46px;
    padding-left: 50px;
    background: url('@/assets/logo/dticon.png') no-repeat 20px center/22px 22px #e5e5e5;
    margin-bottom: 0;
    margin-top: 0;
    font-size: 21px
  }
  .newsone:nth-child(2) p{
    background: url('@/assets/logo/cgicon.png') no-repeat 20px center/26px 26px #e5e5e5;
    margin-bottom: 0;
  }
  .news_middle .newsone:nth-child(1) p{
    background: url('@/assets/logo/lcicon.png') no-repeat 20px center/22px 22px #e5e5e5;
    margin-bottom: 0;
  }
  .news_middle .newsone:nth-child(2) p{
    background: url('@/assets/logo/nricon.png') no-repeat 20px center/22px 22px #e5e5e5;
    margin-bottom: 0;
  }
  .news_bottom .newsone:nth-child(1) p{
    background: url('@/assets/logo/zcicon.png') no-repeat 20px center/22px 22px #e5e5e5;
    margin-bottom: 0;
  }
  .news_bottom .newsone:nth-child(2) p{
    background: url('@/assets/logo/pjicon.png') no-repeat 20px center/22px 22px #e5e5e5;
    margin-bottom: 0;
  }
  .list{
    width: 660px;
    color: #333;
    background-color: #fff;
    float: left;
    margin: 10px 20px;
  }
  .list span{
    display: block;
    width: 97%;
    padding-left: 3%;
    height: 36px;
    line-height: 36px;
    font-size: 18px;
    white-space: nowrap;
    overflow: hidden;
     text-overflow: ellipsis;
  }
  .person{
    width: 1400px;
    min-height:100px;
    margin: 0 auto;
    margin-top: 20px;
  }
  .person p{
    width: 96.5%;
    height: 46px;
    line-height: 46px;
    padding-left: 50px;
    background: url('@/assets/logo/zjicon.png') no-repeat 20px center/22px 22px #e5e5e5;
    margin-bottom: 0;
    font-size: 21px
  }
  .person .list{
    width: 96%;
    padding:0 2%;
    background-color: #fff;
    height: 230px;
    margin: 0 !important;
    display:flex;
    justify-content: space-between; 
  }
  .person .list img{
    display: block;
    width: 140px;
    height:190px;
    /* height:auto; */
    float: left;
    margin-top: 20px;
  }
  .bottom{
    width:100%;
    height:30px;
    background-color: #084bb7;
    text-align: center;
     color: #999;
    /* margin-top: 20px; */
  }
.bottom a {
  color: white;
  text-decoration: none;
}
  .c_bottom1{
	display:flex;
	justify-content: space-between; 
	flex-wrap: wrap; 
	margin-top: 30px;
  }
  .c_bottom1 .zy{
	flex: 0 0 29%;
	text-align: center;
	border: 1px solid #eee;
	box-shadow: 0px 5px 10px #ccc;
	height: 200px;
	padding: 0 20px;
	margin-bottom: 20px;
  }
  .c_bottom1 .zy h6{
	margin: 0 !important;
	padding-top: 70px !important;
  }
  .c_bottom1 .zy p{
	text-align: left;
  }
  .c_bottom1 .zy:nth-child(1){
	background: url('@/assets/logo/jl.png') no-repeat center 10px/60px 60px;
  }
  .c_bottom1 .zy:nth-child(2){
  	background: url('@/assets/logo/zc.png') no-repeat center 10px/60px 60px;
  }
  .c_bottom1 .zy:nth-child(3){
  	background: url('@/assets/logo/ys.png') no-repeat center 10px/60px 60px;
  }
  .c_bottom1 .zy:nth-child(4){
  	background: url('@/assets/logo/rk.png') no-repeat center 10px/60px 60px;
  }
  .c_bottom1 .zy:nth-child(5){
  	background: url('@/assets/logo/jy.png') no-repeat center 10px/60px 60px;
  }
  .c_bottom1 .zy:nth-child(6){
  	background: url('@/assets/logo/tg.png') no-repeat center 10px/60px 60px;
  }
  .c_bottom1>.el-steps--horizontal{
	  margin: 0 auto;
  }
  .bottom img{
    display: block;
    width: 80px;
    height:80px;
    margin:0 auto;
  }
  ::v-deep .el-step{
	  width: 200px;
	  margin-top: 20px;
  }
  ::v-deep .el-step__icon {
      border: none;
      background: #cccccc;
  }
  ::v-deep .el-step__title.is-finish{
      color: #084bb7;
  }
  ::v-deep .el-step__head.is-finish {
      border-color: #084bb7;
  }
  ::v-deep .el-step__icon-inner {
      color: #084bb7;
  }
  .b_top{
    width: 600px;
    height: 30px;
    margin: 0 auto;
    display:flex;
    justify-content: space-between; 
    padding-top: 20px;
  }
  .b_top>div{
    color:#fff;
    border-right:1px solid #fff;
    width: 130px;
    height:20px;
    line-height: 20px;
    text-align: center;
  }
  .b_top>div:last-child{
    border-right:none;
  }
  .b_footer{
    width: 600px;
    margin:0 auto;
    text-align: center;
    color: #fff;
    line-height:32px;
    padding-top: 40px;
  }
  .b_footer1{
    width: 900px;
    margin:0 auto;
    text-align: center;
    color: #fff;
    line-height:32px;
  }
  .ant-tabs-ink-bar{
    display: none !important;
  }
  .ant-tabs-nav .ant-tabs-tab-active {
      font-size: 26px !important;
      margin-top:30px;
  }
  .ant-tabs-top-content{
    margin-top:50px;
  }
  .ant-col .ant-form-item-control-wrapper{
    /* display:none !important; */
  }
  .ant-form-item-control{
    line-height:39px !important;
  }
  ::v-deep.login-button{
      background: #123d65 !important;
      border-radius: 90px !important;
  }
  ::v-deep.ant-tabs-ink-bar-animated{
    display: none !important;
  }
  ::v-deep.ant-tabs-nav .ant-tabs-tab:hover{
    color:#084bb7 !important;
    font-size: 26px !important;
  }
  ::v-deep.ant-tabs-nav .ant-tabs-tab-active{
    color:#084bb7 !important;
    font-size: 26px !important;
  }  
/* 科技查新 */
  .title_technology{
    width: 100%;
    height: 40px;
    /* line-height: 66px; */
    text-align: center;
    font-size: 25px;
    font-weight: bold;
    padding-top: 10px;
  }
  .c_new_technology{
    width: 92%;
    margin:0 auto;
    background-color: #fff;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    min-height: 200px;
    border-radius: 4px;
    border: 1px solid #EBEEF5;
    padding: 30px;
  }
  .c_bottom_technology{
	display:flex;
	justify-content: center; 
	flex-wrap: wrap; 
	margin-top: 10px;
  }
  .c_bottom_technology .zy{
	flex: 0 0 15%;
	text-align: center;
	border: 1px solid #eee;
	box-shadow: 0px 5px 10px #ccc;
	height: 100px;
	padding: 0 10px;
	margin-bottom: 10px;
  }
  .c_bottom_technology .zy h6{
	margin: 0 !important;
	padding-top: 70px !important;
  }
  .c_bottom_technology .zy p{
	text-align: left;
  }
  .c_bottom_technology .zy:nth-child(1){
	background: url('@/assets/logo/zc.png') no-repeat center 10px/60px 60px;
  }
  .c_bottom_technology .zy:nth-child(2){
  	background: url('@/assets/logo/jl.png') no-repeat center 10px/60px 60px;
  }
  .c_bottom_technology .zy:nth-child(3){
  	background: url('@/assets/logo/ys.png') no-repeat center 10px/60px 60px;
  }
  .c_bottom_technology .zy:nth-child(4){
  	background: url('@/assets/logo/rk.png') no-repeat center 10px/60px 60px;
  }
  .c_bottom_technology>.el-steps--horizontal{
	  margin: 0 auto;
  }


  .form-group {
    display: flex;
    /* align-items: center; 垂直居中 */
    margin-bottom: 18px; /* 每个表单组之间的间距 */
  }
 
  .form-group label{
    min-width: 150px;
    margin-right: 13px; /* 标签和输入框之间的间距 */
    flex-shrink: 0; /* 防止标签在输入框内容过多时被压缩 */
    text-align: right; 
  }
 
  .form-group input {
    flex-grow: 1; /* 输入框占据剩余空间 */
    text-align: left; 
  }



  /* 知名专家 */
  
  .c_bottom_export{
	display:flex;
	justify-content: space-between; 
	flex-wrap: wrap; 
	margin-top: 10px;
  }
  .c_bottom_export .zy{
	flex: 0 0 29%;
	text-align: center;
	border: 1px solid #eee;
	box-shadow: 0px 5px 10px #ccc;
	height: 350px;
	padding: 0 20px;
	margin-bottom: 20px;
  }
  .c_bottom_export .zy h6{
	margin: 0 !important;
	padding-top: 70px !important;
  }
  .c_bottom_export .zy p{
	text-align: left;
  }
  .c_bottom_export .person{
    width: 400px;
    min-height:100px;
    margin: 0 auto;
    margin-top: 20px;
  }
  .c_bottom_export .person p{
    width: 50%;
    height: 16px;
    line-height: 46px;
    padding-left: 50px;
    /* background: url('@/assets/logo/zjicon.png') no-repeat 20px center/22px 22px #e5e5e5; */
    margin-bottom: 0;
    font-size: 20px
  }
  .c_bottom_export .person .list{
    width: 100%;
    padding:0 2%;
    background-color: #fff;
    height: 150px;
    margin: 0 !important;
    display:flex;
    justify-content: space-between; 
  }
  .c_bottom_export .person .list img{
    display: block;
    width: 100px;
    height: 140px;
    /* height:auto; */
    float: left;
    margin-top: 10px;
  }
  .c_bottom_export>.el-steps--horizontal{
	  margin: 0 auto;
  }

  .nav_field{
    width: 70%; 
    position: absolute;
    top: 375px;
    height: 72px; 
    /* background-color: rgba(0,0,0,0.4); */
  }
  .navdh_field{
    /* margin-left: 50px; */
    width: 90%;
    margin: 0 auto;
    display:flex;
    justify-content: space-between; 
  }
  .field{
    /* width: 120px;
    text-align: center;
    cursor: pointer;
    color:#fff;
    font-size: 10px;
    line-height:62px; */

    /* width: 1200px; */
    height: auto;
    min-height: 50px;
    /* padding: 25px 0px 40px 20px; */
    text-align: left;
    cursor: pointer;
    font-size: 16px;
    line-height:52px;
  }

  .nav_search{
    text-align: right;
    /* margin-top: 8px; */
    font-size: 16px;
    height: 30px;
  }

   /* 政策标准 */
    
   .c_bottom_policy{
      display:flex;
      justify-content: space-between; 
      flex-wrap: wrap; 
      /* margin-top: 80px; */
    }
    /* .c_bottom_policy  .list{
      width: 956px;
      height: 10px;
      color: #333;
      background-color: #fff;
      margin-top: 20px;
    }


    .c_bottom_policy .list span{
      display: block;
      width: 97%;
      padding-left: 3%;
      height: 20px;
      line-height: 20px;
      font-size: 18px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
  } */
    .c_bottom_policy .zy{
      flex: 0 0 97%;
      text-align: left;
      border: 1px solid #eee;
      box-shadow: 0px 5px 10px #ccc;
      /* height: 700px; */
      /* width: 1550px; */
      padding: 0 20px;
      margin-bottom: 20px;
    }
    .c_bottom_policy .zy h6{
      margin: 0 !important;
      padding-top: 70px !important;
    }
    .c_bottom_policy .zy p{
      text-align: left;
    }
    /* .c_bottom_policy .person{
      width: 400px;
      min-height:100px;
      margin: 0 auto;
      margin-top: 20px;
    }
    .c_bottom_policy .person p{
      width: 50%;
      height: 16px;
      line-height: 46px;
      padding-left: 50px;
      background: url('@/assets/logo/zjicon.png') no-repeat 20px center/22px 22px #e5e5e5;
      margin-bottom: 0;
      font-size: 2px
    }
    .c_bottom_policy .person .list{
      width: 100%;
      padding:0 2%;
      background-color: #fff;
      height: 150px;
      margin: 0 !important;
      display:flex;
      justify-content: space-between; 
    }
    .c_bottom_policy .person .list img{
      display: block;
      width: 100px;
      height: 140px;
      float: left;
      margin-top: 10px;
    }

    .c_bottom_policy>.el-steps--horizontal{
        margin: 0 auto;
    } */



    ::v-deep .el-tabs__item {
        font-size: 20px; /* 设置你想要的字体大小 */
        /* color: #f10b0b; */
  }


   /* 知名专家详情 */
    
   .c_bottom_export_detail{
      display:flex;
      justify-content: space-between; 
      flex-wrap: wrap; 
      margin-top: 30px;
    }
    .c_bottom_export_detail .zy{
      flex: 0 0 97%;
      text-align: center;
      border: 1px solid #eee;
      box-shadow: 0px 5px 10px #ccc;
      height: 500px;
      /* width: 1550px; */
      padding: 0 20px;
      margin-bottom: 20px;
    }
    .c_bottom_export_detail .zy h6{
      margin: 0 !important;
      padding-top: 70px !important;
    }
    .c_bottom_export_detail .zy p{
      text-align: left;
    }
    .c_bottom_export_detail .person{
      width: 400px;
      min-height:100px;
      margin: 0 auto;
      margin-top: 20px;
    }
    .c_bottom_export_detail .person p{
      width: 50%;
      height: 16px;
      line-height: 46px;
      padding-left: 50px;
      /* background: url('@/assets/logo/zjicon.png') no-repeat 20px center/22px 22px #e5e5e5; */
      margin-bottom: 0;
      font-size: 2px
    }
    .c_bottom_export_detail .person .list{
      width: 100%;
      padding:0 2%;
      background-color: #fff;
      height: 150px;
      margin: 0 !important;
      display:flex;
      justify-content: space-between; 
    }
    .c_bottom_export_detail .person .list img{
      display: block;
      width: 100px;
      height: 140px;
      /* height:auto; */
      float: left;
      margin-top: 10px;
    }

    .c_bottom_export_detail>.el-steps--horizontal{
        margin: 0 auto;
    }

    .formFont{
      width: 100px;
      height: 25px;
    }
    .custom-select {
      width: 600px; /* 设置下拉菜单的宽度 */
      padding: 5px; /* 可选：设置内边距 */
      font-size: 16px; /* 可选：设置字体大小 */
    }
    table {
      width: 100%;
      border-collapse: collapse;
    }
    
    th, td {
      border: 1px solid #ddd;
      padding: 8px;
      text-align: left;
      background-color: #f9f9f9;
    }
    
    th {
      background-color: #f2f2f2;
    }
    
    /* tr:nth-child(even) {
      background-color: #f9f9f9;
    } */

    #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 60px;
  }

  ::v-deep .el-tabs__item {
    margin-top: 20px;
  }

  ::v-deep .el-tabs__item.is-active, .el-tabs__item:hover {
    color: #084bb7;
  }

  ::v-deep .el-tabs__active-bar, .is-top{
    background-color: #084bb7;
  }

  ::v-deep .button{
    background: #084bb7
  }

  .buttonClass {
    background-color: #084bb7;
    color: white;
    border: none;
    padding: 3px 7px;
    cursor: pointer;
 }
 .panationClass{
  margin-left: 15px;
  margin-right: 15px;
 }
 .example-pagination-block + .example-pagination-block {
  margin-top: 10px;
}
.example-pagination-block .example-demonstration {
  margin-bottom: 16px;
}

.pdf-viewer {
  /* 你可以为包含iframe的容器设置样式 */
  text-align: center; /* 例如，让iframe居中 */
  padding: 20px; /* 添加一些内边距 */
}
 
.pdf-iframe {
  /* 设置iframe的边框样式 */
  border: none; /* 黑色实线边框，宽度为2px */
  width: 100%; /* 设置iframe的宽度为容器的100% */
  height: 600px; /* 设置iframe的高度，你可以根据需要调整 */
  /* 其他样式，如边框半径、阴影等 */
  border-radius: 8px; /* 圆角边框 */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* 添加一些阴影效果 */

}

.clickable-link {
  cursor: pointer; /* 改变光标样式为手形 */
  
}
 
/* 可选的悬停效果，增强用户体验 */
.clickable-link:hover {
  text-decoration: none; /* 移除下划线，当用户悬停时 */
  color: #084bb7; /* 添加背景色，表示可交互 */
}
.scroll-container {
  display: flex;
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  -webkit-overflow-scrolling: touch; /* 启用平滑滚动 */
}
 
.scroll-item {
  flex: none;
  scroll-snap-align: start;
  margin-right: 66px; /* 图片之间的间距 */
}
 /* height: auto */
.scroll-item img {
  display: block;
  width: 300px; /* 设置图片的宽度 */  
  height: 200px; /* 保持图片比例 */
}
/* 浮动按钮样式 */
.fab-container {
  position: fixed;
  bottom: 80px;
  right: 22px;
}

.fab-button {
  background-color: #084bb7;
  color: white;
  border: none;
  /* border-radius: 50%; */
  width: 79px;
  height: 50px;
  font-size: 19x;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.26);
  cursor: pointer;
  outline: none;
  display: flex;
  align-items: center;
  justify-content: center;
}
/* 对话框样式 */
.dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  /* 根据需要调整 */
}

.dialog-content {
  background: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  text-align: center;
  width: 30%;
}

.dialog-content textarea {
  width: calc(100% - 40px);
  padding: 10px;
  margin: 10px 0;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 15px;
}

.dialog-content button {
  padding: 10px 20px;
  margin: 5px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  outline: none;
}

.dialog-content button:not(:last-child) {
  margin-right: 10px;
}
</style>